<template>
  <div class="section">
    <div class="container">
      <!-- RESET PASSWORD  -->
      <div id="handleResetPassword" v-if="views.handleResetPassword">
        <h2 class="is-size-4 has-text-weight-semibold">Yeni Şifre Oluştur</h2>

        <article class="message is-danger mt-1" v-if="isErr">
          <div class="message-body">{{ errMsg }}</div>
        </article>

        <form @submit.prevent="handleResetPassword" class="auth-form mt-1" v-if="!signedIn">
          <div class="field">
            <label class="label" for="newPassword">Yeni Şifre</label>
            <div class="control has-icons-right">
              <input
                type="password"
                name="newPassword"
                class="input is-medium"
                placeholder="Yeni şifrenizi girin"
                v-model="newPassword"
                minlength="6"
                maxlength="24"
                @focus="toggleNav(false)"
                @blur="toggleNav(true)"
                autocomplete="off"
                required
              />
              <span class="icon is-small is-right">
                <i class="fas fa-lock"></i>
              </span>
              <!-- <p class="help is-danger" v-show="isErr">{{errMsg}}</p> -->
            </div>
          </div>

          <div class="field mt-1">
            <div class="control">
              <button
                class="button has-text-black-bis is-primary is-medium is-fullwidth"
                :class="{ 'is-loading': isLoading }"
              >Onayla</button>
            </div>
          </div>
        </form>

        <article class="message is-success mt-1" v-if="signedIn">
          <div class="message-body">
            Şifre başarıyla değiştirildi.
            <span class="has-text-black-bis">{{ time }}</span> saniye içinde anasayfaya yönlendirilmezseniz bu
            <router-link class="has-text-link" to="/">linke tıklayın</router-link>.
          </div>
        </article>
      </div>
      <!-- ./RESET PASSWORD  -->

      <!-- EMAIL VERIFICATION -->
      <div id="handleVerifyEmail" v-else-if="views.handleVerifyEmail">
        <h2 class="is-size-4 has-text-weight-semibold">E-posta doğrulama</h2>

        <!-- not verified -->
        <article class="message is-danger mt-1" v-if="isErr">
          <div class="message-body">
            {{errMsg}}
            <a class="has-text-link" @click="sendVerificationMail">Tekrar gönder</a>
          </div>
        </article>

        <article class="message is-success mt-1" v-if="isVerificationEmailSent">
          <div class="message-body">Doğrulama linki e-posta adresine gönderildi.</div>
        </article>

        <!-- <p>E-posta doğrulama linkini <a @click="sendEmailVerification">tekrar gönder</a></p> -->

        <h3 class="is-size-5 is-success" v-if="emailVerified">Email adresiniz başarıyla doğrulandı.</h3>
        <p v-if="emailVerified">
          {{ time }} Saniye içinde anasayfaya yönlendirilmezseniz bu
          <router-link :to="continueUrl !== '' ? continueUrl : '/'">linke</router-link>tıklayın.
        </p>
      </div>
      <!-- ./EMAIL VERIFICATION -->

      <div v-else>
        <h2>Something went wrong</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "@/fireinit";
import { setInterval, clearInterval } from "timers";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      views: {
        handleResetPassword: false,
        handleVerifyEmail: false
      },
      mode: "",
      actionCode: "",
      continueUrl: "",
      lang: "",
      email: "",
      newPassword: "",
      emailVerified: false,
      isVerificationEmailSent: false,
      isErr: false,
      errMsg: "",
      isLoading: false,
      signedIn: false,
      time: 6,
      isRunning: false,
      interval: null,
      redirectUrl: "/"
    };
  },
  methods: {
    ...mapActions({
      sendEmailVerification: "auth/sendEmailVerification"
    }),
    ...mapMutations({
      toggleNav: "ui/TOGGLE_NAVBAR"
    }),
    async sendVerificationMail() {
      try {
        await this.sendEmailVerification();
        this.isErr = false;
        this.isVerificationEmailSent = true;
      } catch (error) {
        this.isErr = true;
        this.errMsg =
          "Doğrulama postası gönderirken hata oluştu. Sayfayı yenileyip tekrar deneyin.";
      }
    },
    // countdown
    toggleTimer() {
      if (this.isRunning) {
        clearInterval(this.interval);
        // console.log("timer stops")
      } else {
        this.interval = setInterval(this.incrementTime, 1000);
      }
      this.isRunning = !this.isRunning;
    },
    incrementTime() {
      this.time = parseInt(this.time) - 1;
      if (this.time < 1) {
        this.isRunning = false;
        clearInterval(this.interval);
        window.location.href = this.redirectUrl;
      }
    },
    // ./countdown
    getParameterByName(param) {
      console.log(this.$route.query[param]); //todo: delete
      return this.$route.query[param];
    },
    async handleResetPassword() {
      // Localize the UI to the selected language as determined by the lang
      // parameter.
      this.isLoading = true;
      // Verify the password reset code is valid.
      try {
        const accountEmail = await auth.verifyPasswordResetCode(
          this.actionCode
        );
        await auth.confirmPasswordReset(
          this.actionCode,
          this.newPassword
        );
        // Password reset has been confirmed and new password updated.
        // TODO: Display a link back to the app, or sign-in the user directly
        // if the page belongs to the same domain as the app:
        // auth.signInWithEmailAndPassword(accountEmail, newPassword);
        // TODO: If a continue URL is available, display a button which on
        // click redirects the user back to the app via continueUrl with
        // additional state determined from that URL's parameters.
        await auth.signInWithEmailAndPassword(accountEmail, this.newPassword);
        this.signedIn = true;
        this.isLoading = false;

        this.redirectUrl = process.env.VUE_APP_EMAIL_VERIFICATION_CONTINUE_URL;
        this.time = 2;
        this.toggleTimer();
      } catch (error) {
        // console.log(error); // todo: delete
        this.isErr = true;
        this.errMsg = "Bir hata oluştu lütfen tekrar deneyin";
      }
    },
    // handleRecoverEmail(actionCode, lang) {},
    async handleVerifyEmail() {
      // Try to apply the email verification code.
      try {
        await auth.applyActionCode(this.actionCode);
        // Email address has been verified.

        // TODO: Display a confirmation message to the user.
        // You could also provide the user with a link back to the app.
        this.emailVerified = true;

        // TODO: If a continue URL is available, display a button which on
        // click redirects the user back to the app via continueUrl with
        // additional state determined from that URL's parameters.
        // console.log("continue URL", this.continueUrl);
        this.redirectUrl = this.continueUrl;
        this.toggleTimer();
      } catch (error) {
        // Code is invalid or expired. Ask the user to verify their email address
        // again.
        this.isErr = true;
        this.errMsg = "Doğrulama linki geçersiz yada zaman aşımına uğramış";
      }
    }
  },
  mounted() {
    // Get the action to complete.
    this.mode = this.getParameterByName("mode");
    // Get the one-time code from the query parameter.
    this.actionCode = this.getParameterByName("oobCode");
    // (Optional) Get the continue URL from the query parameter if available.
    this.continueUrl = this.getParameterByName("continueUrl");
    // (Optional) Get the language code if available.
    this.lang = this.getParameterByName("lang") || "en";

    // Handle the user management action.
    switch (this.mode) {
      case "resetPassword":
        // Display reset password handler and UI.
        this.views.handleResetPassword = true;
        break;
      case "verifyEmail":
        // Display email verification handler and UI.
        this.views.handleVerifyEmail = true;
        this.handleVerifyEmail();
        break;
      default:
        console.log("error: invalid mode");
      // Error: invalid mode.
    }
  }
};
</script>
